import { React, useState, useEffect } from "react";
import Link from "next/link";
import { useRouter } from "next/router";

function MainNav() {
  const router = useRouter();
  const isSpanishSite =
    router.pathname.startsWith("/es") || router.pathname === "/";
  const isEnglishSite = router.pathname.startsWith("/en");
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [router.pathname]);

  useEffect(() => {
    const findTitle = router.pathname;
    if (findTitle.startsWith("/es/inventario")) {
      document.title = "TU | Inventario";
      return;
    }
    if (findTitle === "/es/contactenos") {
      document.title = "TU | Contáctenos";
      return;
    }
    if (findTitle === "/es/servicios/analisis-de-fluidos") {
      document.title = "TU | Servicios — Análisis de fluidos";
      return;
    }
    if (findTitle === "/es/servicios/programas-de-mantenimiento-preventivo") {
      document.title = "TU | Servicios — Mantenimiento preventivo";
      return;
    }
    if (findTitle === "/es/formulas-hidraulicas") {
      document.title = "TU | Fórmulas hidráulicas";
      return;
    }
    if (findTitle.startsWith("/en/inventory")) {
      document.title = "TU | Inventory";
      return;
    }
    if (findTitle.startsWith("/en/video-blogs")) {
      document.title = "TU | Video-Blogs";
      return;
    }
    switch (findTitle) {
      case "/":
      case "/en":
        document.title = "TU | Technical Union";
        break;
      case "/products":
      case "/en/products":
        document.title = "TU | Products";
        break;
      case "/services/fluid-analysis":
      case "/en/services/fluid-analysis":
        document.title = "TU | Services";
        break;
      case "/inventory":
      case "/en/inventory":
        document.title = "TU | Inventory";
        break;
      case "/fluid-power-formulas":
      case "/en/fluid-power-formulas":
        document.title = "TU | Formulas";
        break;
      case "/interactive":
        document.title = "TU | Interactive";
        break;
      case "/es":
        document.title = "TU | Technical Union";
        break;
      default:
        break;
    }
  }, [router.pathname]);

  return (
    <nav className="tu-navbar">
      <div className="tu-navbar__inner">
        <Link href={isSpanishSite ? "/es" : "/en"} className="tu-navbar__brand" prefetch={false}>
          <strong>TU</strong>
        </Link>
        <button
          className="tu-navbar__toggler"
          type="button"
          aria-controls="tu-main-nav-menu"
          aria-expanded={menuOpen}
          aria-label="Toggle navigation"
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span className="tu-navbar__toggler-icon" aria-hidden="true">
            <span />
            <span />
            <span />
          </span>
        </button>
        <div
          id="tu-main-nav-menu"
          className={`tu-navbar__menu${menuOpen ? " tu-navbar__menu--open" : ""}`}
        >
          <ul className="tu-navbar__list">
            <li className="tu-navbar__item">
              <Link
                href={isSpanishSite ? "/es" : "/en"}
                className="tu-navbar__link"
                prefetch={false}
              >
                {isSpanishSite ? "Inicio" : "Home"}
              </Link>
            </li>
            <li className="tu-navbar__item">
              <Link
                href={isSpanishSite ? "/es/productos" : "/en/products"}
                className="tu-navbar__link"
                prefetch={false}
              >
                {isSpanishSite ? "Productos" : "Products"}
              </Link>
            </li>
            <li className="tu-navbar__item">
              <Link
                href={
                  isSpanishSite
                    ? "/es/servicios/analisis-de-fluidos"
                    : "/en/services/fluid-analysis"
                }
                className="tu-navbar__link"
                prefetch={false}
              >
                {isSpanishSite ? "Servicios" : "Services"}
              </Link>
            </li>
            <li className="tu-navbar__item">
              <Link
                href={isSpanishSite ? "/es/inventario" : "/en/inventory"}
                className="tu-navbar__link"
                prefetch={false}
              >
                {isSpanishSite ? "Inventario" : "Inventory"}
              </Link>
            </li>
            <li className="tu-navbar__item">
              <Link
                href={
                  isSpanishSite
                    ? "/es/formulas-hidraulicas"
                    : "/en/fluid-power-formulas"
                }
                className="tu-navbar__link"
                prefetch={false}
              >
                {isSpanishSite ? "Fórmulas" : "Formulas"}
              </Link>
            </li>
            <li className="tu-navbar__item">
              <Link
                href={isSpanishSite ? "/es/video-blog" : "/en/video-blogs"}
                className="tu-navbar__link"
                prefetch={false}
              >
                Video-Blogs
              </Link>
            </li>
            <li className="tu-navbar__item">
              <Link
                href={isSpanishSite ? "/es/contactenos" : "/en/contact-us"}
                className="tu-navbar__link"
                prefetch={false}
              >
                {isSpanishSite ? "Contáctenos" : "Contact Us"}
              </Link>
            </li>
            <li
              className="tu-navbar__item nav-main-lang"
              aria-label="Language"
            >
              <Link
                href="/en"
                className={`tu-navbar__link nav-main-lang-link${
                  isEnglishSite ? " active" : ""
                }`}
                aria-current={isEnglishSite ? "true" : undefined}
                prefetch={false}
              >
                EN
              </Link>
              <span className="nav-main-lang-sep" aria-hidden="true">
                |
              </span>
              <Link
                href="/es"
                className={`tu-navbar__link nav-main-lang-link${
                  isSpanishSite ? " active" : ""
                }`}
                aria-current={isSpanishSite ? "true" : undefined}
                prefetch={false}
              >
                ES
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default MainNav;
